import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PlatformCommunicatorAuthService } from './platform-communicator.auth.service';
import { ParametersService } from '../../parameters/parameters.service';
import { CipherCommunicatorService } from './cipher-communicator/cipher-communicator.service';
import { AbreCuentasService } from '../../abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from '../channel-communicator/channel-communicator.service';
import { PlatformEndpointService } from '../endpoint/endpoint.service';
import { RequestHeaderSettings } from './request.header.settings';
import { IWebRequestOptions } from 'src/app/shared/interfaces/web-request.interface';
import { PlatformCommunicatorInterceptor } from './platform-communicator.interceptor';
import { LogDeviceModel } from 'src/app/shared/models/log-device.model';

@Injectable({
  providedIn: 'root',
})
export class PlataformCommunicatorBitacaraService {

  parametrizedHeaders: HttpHeaders | undefined = undefined;
  private communicatorInterceptor: PlatformCommunicatorInterceptor;

  constructor(
    private _http: HttpClient,
    private authService: PlatformCommunicatorAuthService,
    private parametersService: ParametersService,
    private abreCuentasService: AbreCuentasService,
    private endpointService: PlatformEndpointService,
    private channelCommunicatorService: ChannelCommunicatorService,
  ) { }

  async saveDataInBitacora(
    error: HttpErrorResponse,
  ): Promise<any> {
    if (error.status == 404 && error.url != this.endpointService.URLS.TERMS_CONDITIONS) {
      const eventName = `ups_error_${error.status}_${error.url}`;
      const devicePrint = new LogDeviceModel();
      devicePrint.device = this.abreCuentasService.getDeviceInfo();
      devicePrint.device.event_name = eventName;
      devicePrint.terms_type = eventName;
      const headers = new HttpHeaders({
        'token-client-id': '39540626_1',
        'session_id': this.authService.getSessionId(),
      });
      const options = {
        url: this.endpointService.URLS.TERMS_CONDITIONS,
        method: 'post',
        body: devicePrint,
        headers,
      };
      return new Promise((resolve, reject) => {
        this.request(options)
          .then(response => resolve(response.body))
          .catch(err => reject(err));
      });
    }
  }

  private processHeaders(additionalHeaders: HttpHeaders | undefined, url: string, isPpid: boolean, appendSession: boolean): HttpHeaders {
    const token = this.authService.getSSOInformation().accessToken;
    const sessionId = this.authService.getSessionId();
    let headers = RequestHeaderSettings.getHeaders(token, isPpid);
    headers = headers.append('use_cripto', 'false');

    if (url !== this.endpointService.URLS.API_GATEWAY_SSO) {
      headers = headers.append('transaction_id', this.abreCuentasService.getTransactionId());
      headers = headers.append('channel-id', this.channelCommunicatorService.getChannelId().toString());
    }

    if (token && this.abreCuentasService.parametrizedHeaders !== undefined) {
      const keys = this.abreCuentasService.parametrizedHeaders.keys();
      headers = headers.append('operation_target', this.abreCuentasService.parametrizedHeaders.get('operation_target') as string);
      keys.map(chKey => {
        // tslint:disable-next-line: early-exit
        if (chKey === this.channelCommunicatorService.getChannelId() && this.abreCuentasService.parametrizedHeaders !== undefined) {
          const chHead: any = this.abreCuentasService.parametrizedHeaders.get(chKey);

          for (const key in chHead) {
            if (Object.prototype.hasOwnProperty.call(chHead, key)) {
              headers = headers.append(key, chHead[key] as string);
            }
          }
        }
      });
    }

    if (sessionId && appendSession) {
      headers = headers.append('session_id', sessionId as string);
    }

    if (additionalHeaders !== undefined) {
      let requestHeaders = additionalHeaders;

      const keys = headers.keys();

      for (const key of keys) {
        if (requestHeaders.get(key) === null) {
          requestHeaders = requestHeaders.append(key, headers.get(key) as string);
        }
      }

      headers = requestHeaders;
    }

    return headers;
  }

  private getURLRequest(url: string, method: string): string {
    const backendURLMocked = this.parametersService.getParameter('url_mock_backend');
    if (backendURLMocked) {
      return this.communicatorInterceptor.getBackEndURLMocked(backendURLMocked, url, method);
    }
    return url;
  }

  async request(options: IWebRequestOptions, isPpid = false, appendSession = true): Promise<HttpResponse<any>> {
    const headers = this.processHeaders(options.headers, options.url, isPpid, appendSession);
    options.headers = headers;

    return new Promise<HttpResponse<any>>((resolve, reject) => {
      const url = this.getURLRequest(options.url, options.method);
      let fucntionParameters: any[];

      if (url !== options.url) {
        options.method = 'get';
      }

      if (options.method !== 'get' && options.method !== 'delete') {
        fucntionParameters = [
          options.url,
          options.body,
          { headers, params: options.params, observe: 'response' },
        ];
      } else {
        fucntionParameters = [
          url,
          { headers, params: options.params, observe: 'response' },
        ];
      }
      this._http[options.method].apply(this._http, fucntionParameters).toPromise().then(
        async (response: HttpResponse<any>) => {
          if (response.status === 200) {
            resolve(response);
            return;
          }
        }, (error: any) => {
        reject(error);
        return;

      },
      ).catch((error: any) => {
        reject(error);
        return;
      });
    });
  }

}
